export const POPUP = Object.freeze({
  // dialog xac nhan reject account
  RESET_PASSWORD: 'ResetPassword',
  REGISTER_POPUP: 'Register',
  UPDATE_POPUP: 'Update',
  UPDATE_ACCOUNT: 'UpdateAccount',
  UPDATE_HISTORY_POPUP: 'HistoryPanel',
  UPDATE_PARTNER_POPUP: 'UpdatePartner',
  REQUEST_LICENSE_INFO: 'RequestLicenseInfo',
  CREATE_LICENSE_SUMMARY_POPUP: 'CreateLicenseSummary',
  CREATE_BRANCH_POPUP: 'CreateBranch',
  CREATE_LICENSE_DETAIL_POPUP: 'CreateLicenseDetail',
  UPGRADE_BRANCH_POPUP: 'UpgradeBranch',
  EXTEND_BRANCH_POPUP: 'ExtendBranch',
  SAVE_FILTER_TEMPLATE: 'SaveFilterTemplate',
  TWO_FACTOR_AUTH: 'TwoFactorAuth',
  TWO_FACTOR_AUTH_SUCCESS: 'TwoFactorAuthSuccess',
  TWO_FACTOR_AUTH_INFO: 'TwoFactorAuthInfo',
  TWO_FACTOR_OTP: 'TwoFactorOTP',
  ENTER_PWD: 'EnterPassword',
  DATE_FORMAT: 'DateFormat',
});
